import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    // Check length (8-16 characters)
    if (value.length < 8 || value.length > 16) {
      return { passwordLength: true };
    }

    // Check for at least one uppercase letter
    const hasUpperCase = /[A-Z]/.test(value);
    if (!hasUpperCase) {
      return { passwordUpperCase: true };
    }

    // Check for at least one lowercase letter
    const hasLowerCase = /[a-z]/.test(value);
    if (!hasLowerCase) {
      return { passwordLowerCase: true };
    }

    // Check for at least one number
    const hasNumber = /[0-9]/.test(value);
    if (!hasNumber) {
      return { passwordNumber: true };
    }

    // Check for at least one special symbol
    const hasSymbol = /[!@#$%^&*()_+=[\]{};':"\\|,.<>/?-]/.test(value);
    if (!hasSymbol) {
      return { passwordSymbol: true };
    }

    return null;
  };
}
